import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  SmartAlert,
  SmartLoaderInterface,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import { SdsFsDownloadFile } from "soft_digi/dist/services/FileService";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { checkInterSection } from "../../services/core/FilterService";
import { showAlertAutoClose } from "../../services/notifyService";
import { post } from "../../services/smartApiService";
import ChangeDateForm from "../Home/ChangeDateForm";
import SessionForm from "./SessionForm";
// import ChangeDateForm from "./ChangeDateForm";

interface HeaderProps {
  date: string;
}

const SessionDayReport: React.FC<HeaderProps> = ({ date }) => {
  const { openModal, closeModal, user } = useSiteContext();
  const navigate = useNavigate();
  const [tabData, setTabData] = useState([]);
  const is_admin = checkInterSection(user?.roles || [], ["ADMIN", "AGENCY"]);

  const loadTableData = () => {
    let URL = SESSION_URLS.GET_SESSIONS_BY_DATE;
    let data_in = {
      session_date: date,
    };
    const subscription = post(URL, data_in).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
  }, []);
  const CancelData = (id: any) => {
    const subscription = post(SESSION_URLS.CANCEL_SESSION, {
      id: id,
    }).subscribe((response) => {
      showAlertAutoClose("Cancel Successfully...", "success");
      closeModal();
      loadTableData();
      // setLoading(false);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const openCancelModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i> Session Cancel!
        </span>
      ),
      alertFunction: (option) => {
        if (option === "yes") {
          CancelData(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you wish to Cancel this Session? This action cannot be
          reverted
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };

  // const viewEditForm = (data:any) => {
  //  // const selectedData = staticTabData.find((data) => data.ID === id);

  //  openChangeForm(data);
  // };
  const viewEditForm = (id: any) => {
    const subscription = post(SESSION_URLS.GET_ONE, { id: id }).subscribe(
      (response: any) => {
        openChangeForm(response.data);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };
  const openOfficesForm = (data: any) => {
    let options = {
      title: <>{data.ID ? "Session Update Form" : "Session Form"}</>,
      content: <SessionForm dataIn={data} loadTableData={loadTableData} />,
      className: " sd-exam-modal",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };
  const openChangeForm = (data: any) => {
    let options = {
      title: <>{data.ID ? "Change Date Form" : "Change Date Form"}</>,
      content: <ChangeDateForm dataIn={data} loadTableData={loadTableData} />,
      className: "sd-efl-modal sd-exam-modal-one",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };

const onSubmit = (dt: any) => {
  const url = SESSION_URLS.GET_PDF;
  const sessionId = dt["session_id"] || "Session";
  const sessionDate = dt["session_date"]
    ? new Date(dt["session_date"]).toLocaleDateString("en-GB").split("/").reverse().join("-")
    : "Date";

  const fileName = `${sessionId}_${sessionDate}_Report.pdf`;

  const subscription = post(
    url,
    { id: dt["ID"] },
    { loadingMsg: "Downloading... please Wait" }
  ).subscribe((response) => {
    SdsFsDownloadFile(response.data.content, fileName);
  });

  return () => {
    subscription.unsubscribe();
  };
};

  const buttons = [
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-eye",
      classList: ["smart-hims-table-view-icon"],
    onClick: (data: any) => {
  navigate("/admin/session/" + data["ID"]);
  closeModal();
},
      // hideFunction: (d: any) => {
      //   return mode === "planned" || d?.status?.toLowerCase() === "planned";
      // },
    },

    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-clock",
      classList: ["smart-hims-table-edit-icon"],
      onClick: (data: any) => viewEditForm(data["ID"]),
      hideFunction: (d: any) => is_admin || d?.status !== "active",
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-times",
      classList: ["smart-hims-table-delete-icon"],
      onClick: (data: any) => openCancelModal(data["ID"]),
      hideFunction: (d: any) => is_admin || d?.status !== "active",
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-download",
      classList: ["smart-hims-table-view-icon"],
      onClick: (data: any) => onSubmit(data),
      // hideFunction: (data: any) => {
      //   return data["status"] == "completed" ? false : true;
      // },
       hideFunction: (d: any) =>  d?.status !== "completed",
    },
  ];

  // const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
  //   { title: "S.NO", index: "s_no", type: "sno", width: "5" },
  //   { title: "Employee ID", index: "euserid" },
  //   { title: "Name", index: "ename" },
  //   { title: "Mobile Number", index: "mobile_no" },
  //   { title: "Loco -shed", index: "roles" },
  //   {
  //     title: "Action",
  //     index: "action",
  //     type: "buttons",
  //     buttons: buttons,
  //     width: "10",
  //   },
  // ];

  const statusTags = [
    { value: "started", label: "Started", class: "is-info" },
    { value: "active", label: "Active", class: "is-primary" },
    { value: "cancel", label: "Cancel", class: "is-danger" },
    { value: "completed", label: "Completed", class: "is-primary" },
  ];
  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "Agency", index: "agency_name" },
    { title: "Project", index: "project_name" },
    { title: "Session ID", index: "session_id" },

    {
      title: "Date",
      index: "session_date",
      type: "date",
      dateFormat: "DD-MM-YYYY",
    },
    { title: "Venue", index: "location" },
    { title: "No.of Loco Pilots", index: "total_trainees" },
    { title: "status", index: "status", type: "tags", tags: statusTags },
    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "10",
    },
  ];

  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-6",
      custom: <p className="is-size-4 has-text-weight-bold"></p>,
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "JUSTIFY",
    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [
        {
          label: "Create",
          icon: "fa-plus",
          type: "CUSTOM",
          className: "smart-third-button",
          action: () => openOfficesForm({}),
        },
      ],
    },
  ];

  const tableTopAdmin: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-6",
      custom: <p className="is-size-4 has-text-weight-bold"></p>,
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "JUSTIFY",
    },
  ];

  return (
    <div className="sd-efl-input">
      <SmartTable
        columns={columns}
        data={tabData}
        tableTop={is_admin ? tableTopAdmin : tableTop}
        tableProps={{
          className: "is-hoverable is-bordered smart-hims-table",
          isResponsive: true,
          searchPlaceHolder: "Search",
        }}
        paginationProps={{
          pageSize: 10,
        }}
      />
    </div>
  );
};




export default SessionDayReport